import Preview from './presenter';

export default Preview;



// WEBPACK FOOTER //
// ./app/components/Preview/index.js